import AxiosClient from "../AxiosClient";

// 営業カレンダーデータ取得Api
export const postMarketCalendarSearchInfoListAPI = (params) => {
  return AxiosClient.post("/api/marketCalendar/searchInfoList", params);
}

// 営業カレンダー次開場日取得Api
export const postMarketCalendarSearchNextOpenDateInfoAPI = (params) => {
  return AxiosClient.post("/api/marketCalendar/searchNextOpenDateInfo", params);
}
